import api from "./api";

const pdfLayoutService = {
  criar: (tipoLicencaId, headerFile, footerFile) => {
    const formData = new FormData();
    formData.append("tipoLicencaId", tipoLicencaId);
    formData.append("header", headerFile);
    formData.append("footer", footerFile);

    return api.post("PDFLayout/Create", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  listar: () => {
    return api.get("PDFLayout/GetAll");
  },

  obterPorId: (id) => {
    return api.get(`PDFLayout/${id}`);
  },

  obterPorTipoLicenca: (tipoLicencaId) => {
    return api.get(`PDFLayout/ByTipoLicenca/${tipoLicencaId}`);
  },

  obterLatest: () => {
    return api.get("PDFLayout/Latest");
  },

  atualizar: (id, tipoLicencaId, headerFile, footerFile) => {
    const formData = new FormData();
    formData.append("tipoLicencaId", tipoLicencaId);
    if (headerFile) formData.append("header", headerFile);
    if (footerFile) formData.append("footer", footerFile);

    return api.put(`PDFLayout/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  deletar: (id) => {
    return api.delete(`PDFLayout/${id}`);
  },

  getHeaderImage: (id) => {
    return api.get(`PDFLayout/${id}/Header`, { responseType: "blob" });
  },

  getFooterImage: (id) => {
    return api.get(`PDFLayout/${id}/Footer`, { responseType: "blob" });
  },
};

export default pdfLayoutService;
